import { render } from "./VehiclePixBying.vue?vue&type=template&id=10c6fb0e"
import script from "./VehiclePixBying.vue?vue&type=script&lang=js"
export * from "./VehiclePixBying.vue?vue&type=script&lang=js"

import "./VehiclePixBying.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__